import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { CSVLink } from "react-csv";
import Papa from "papaparse";

// Helper function to process columns and data
const processColumnsAndData = (data, columns) => {
  const filteredColumns = columns.filter(
    (col) => col.selected && col.key !== "selectAll" && col.key !== "action"
  );
  const header = filteredColumns.map((col) => col.name);

  const processedData = data.map((item, index) => {
    const row = { "Sr. No": index + 1 };
    filteredColumns.forEach((col) => {
      if (col.selected && col.key !== "serial") {
        row[col.name] = item[col.key];
      }
    });
    return row;
  });

  return { processedData, header };
};

// Function to generate Excel file
export const generateExcel = (data, columns, fileName) => {
  const selectedHeaders = columns?.filter((val) => val.showExcel);
  const { processedData, header } = processColumnsAndData(
    data,
    selectedHeaders
  );

  const ws = XLSX.utils.json_to_sheet(processedData, { header });
  const headerRange = XLSX.utils.decode_range(ws["!ref"]);
  for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
    if (!ws[cellAddress]) ws[cellAddress] = {};
    ws[cellAddress].s = { font: { bold: true } };
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, fileName);
};

// Function to generate PDF file
export const generatePDF = (data, columns, fileName) => {
  const selectedHeaders = columns?.filter((val) => val.showPDF);
  const { processedData, header } = processColumnsAndData(
    data,
    selectedHeaders
  );

  const doc = new jsPDF();
  doc.text("Inventory Data", 14, 22);
  doc.autoTable({
    head: [header],
    body: processedData.map((item) => header.map((head) => item[head] || "")),
    startY: 30,
  });
  doc.save(fileName);
};

// Function to generate CSV file
export const handleCsvGeneration = (data, columns) => {
  const { processedData, header } = processColumnsAndData(data, columns);
  setTimeout(() => {
    document.getElementById("exportCsv").click();
  }, 500);
  return processedData;
};

export const generateCSV = (data, fileName) => {
  return (
    <CSVLink
      data={data}
      filename={fileName}
      style={{ display: "none" }}
      id="exportCsv"
    >
      Download CSV
    </CSVLink>
  );
};

export const readFile = (file, fileType) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const data = event.target.result;

      if (fileType === ".csv") {
        Papa.parse(data, {
          header: true,
          skipEmptyLines: true, // Skip empty rows
          transformHeader: (header) => {
            // Clean up headers by trimming and removing extra spaces
            return header.trim().replace(/\s+/g, ' ');
          },
          transform: (value, field) => {
            // Process cell values
            if (value === undefined || value === null) return "";
            value = value.toString().trim();
            // No need to transform N/A values here as we'll handle them in validation
            return value;
          },
          complete: (results) => {
            console.log("CSV parsed successfully with", results.data.length, "rows");
            resolve(results.data);
          },
          error: (error) => reject(error),
        });
      } else if (fileType === ".xlsx") {
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(sheet, { 
          defval: "", // Default value for empty cells
          raw: false // Convert to string to handle dates and other types
        });
        console.log("Excel parsed successfully with", json.length, "rows");
        resolve(json);
      } else {
        reject(new Error("Unsupported file type"));
      }
    };

    reader.onerror = (error) => reject(error);
    reader.readAsBinaryString(file);
  });
};
